/* eslint-disable react/display-name */
import React from 'react'
//TODO: fix this dependency
import { useLogin } from 'plugin/src/popup/hooks/useLogin'
import { useTrackMutation } from '@mote/api'
import { useMergeRefs } from '@mote/helpers'
import { TRACK_EVENT_NAMES } from '@mote/helpers/constants'
import { useFlightRecorder } from '@mote/helpers/contexts'
import { Diagnostics, DiagnosticsLogger } from '@mote/helpers/diagnostics'
import { RecordingError } from '@mote/recipes'
import { MotePlayerProviders } from '../../../../shared/components'
import { DraggableRecorder } from './DraggableRecorder'
import { DraggableRecorderPlayback } from './DraggableRecorderPlayback'

const logD = new DiagnosticsLogger('draggable-recording-window')

export const DraggableRecorderWindow = React.forwardRef(
  (
    {
      onClose,
      onInsert,
      onStartRecording,
      disableAutoDebit,
      exposeCancelRecording,
      app
    },
    ref
  ) => {
    const isLoggedIn = useLogin()
    const [showPlayback, setShowPlayback] = React.useState(false)
    const draggableRecorderRef = React.useRef(null)

    const refs = useMergeRefs(draggableRecorderRef, ref)

    const [loginError, setLoginError] = React.useState(false)

    const [pollingLimitExceededError, setPollingLimitExceededError] =
      React.useState(null)
    const [error, setError] = React.useState(false)
    const { mutate: track } = useTrackMutation()
    const { flightState } = useFlightRecorder()

    React.useEffect(() => {
      if (isLoggedIn || loginError) return

      logD.error('Not logged in', { app })

      track({ variables: { event: TRACK_EVENT_NAMES.error.moteCreateLogin } })

      setLoginError(true)
    }, [isLoggedIn, loginError])

    React.useEffect(() => {
      let timeoutId
      const shouldShowError = Boolean(loginError || pollingLimitExceededError)

      if (shouldShowError) {
        draggableRecorderRef.current?.cancelRecording?.()
        timeoutId = setTimeout(() => setError(true), 250)
      }

      return () => clearTimeout(timeoutId)
    }, [loginError, pollingLimitExceededError])

    function handleInsert(mote) {
      onInsert(mote)
      onClose()
    }

    if (error) {
      return loginError ? (
        <RecordingError type={'NOT_LOGGED_IN'} onClose={onClose} />
      ) : pollingLimitExceededError ? (
        <RecordingError type={'POLLING_THRESHOLD_EXCEEDED'} onClose={onClose} />
      ) : null
    }

    if (showPlayback) {
      return (
        <MotePlayerProviders moteId={flightState.moteId}>
          <DraggableRecorderPlayback
            ref={ref}
            onInsert={handleInsert}
            onDelete={() => {
              setShowPlayback(false)
            }}
            onClose={onClose}
            onError={error => {
              setPollingLimitExceededError(true)

              logD.error('Polling for [isPlayable: true] time limit exceeded', {
                error,
                app
              })

              Diagnostics.dispatch({
                userVisibleErrorMessage:
                  'Something went wrong with your recording. Please try again or kindly contact support...',
                dispatchContext: 'DRAGGABLE_RECORDING_WINDOW',
                title: 'Mote isPlayable polling time limit exceeded'
              })
            }}
          />
        </MotePlayerProviders>
      )
    }

    return (
      <DraggableRecorder
        ref={refs}
        onFinalize={() => {
          setShowPlayback(true)
        }}
        disableAutoDebit={disableAutoDebit}
        onClose={onClose}
        onStartRecording={onStartRecording}
        exposeCancelRecording={exposeCancelRecording}
        app={app}
      />
    )
  }
)
